const errorCodes = {
  "01": "01 - Required field missing",
  "02": "02 - User id or Sender id is invalid",
};
export default errorCodes;
